import Auth from "./auth";
import Emitter, { EventTypes } from "../utils/Emitter";
import axios from "axios";
import { Notyf } from "notyf";
import { cors } from "../utils/Cors";

const notyf = new Notyf({
  position: {
    x: "center",
    y: "cneter",
  },
});
const toast = {
  error(message) {
    notyf.error(message);
  },
};
// Keep the body callers already expect, but tag the status so Auth.tryRefresh
// can tell a rejected session apart from a transient failure.
const withStatus = (data, status) =>
  data && typeof data === "object" ? { ...data, httpStatus: status } : data;

export default class Request {
  constructor(headers) {
    cors();
    this.http = axios.create({
      baseURL: process.env.REACT_APP_URL,
      withCredentials: false,
    });

    this.http.interceptors.request.use(async (config) => {
      let token = Auth.getToken()?.token;
      if (headers?.responseType) {
        config.responseType = headers?.responseType;
      }
      const hasExplicitAuth = headers && "Authorization" in headers;
      config.headers = {
        ...(!hasExplicitAuth && { Authorization: token ? `Bearer ${token}` : "" }),
        ...headers,
      };
      return config;
    });
    this.http.interceptors.response.use(
      async (response) => {
        return response;
      },
      async (error) => {
        console.error("error", error);
        if (error.response) {
          // forbidden: 403
          // unauthrized: 401
          // not found: 400
          if (error.response.status && error.response.status === 403) {
            return Promise.reject(withStatus(error.response.data, 403));
          } else if (error.response.status && error.response.status === 401) {
            const isRefreshEndpoint = error.config?.url?.includes("refresh-token");
            if (!isRefreshEndpoint) {
              Emitter.emit(EventTypes.INVALID_TOKEN);
            }
            return Promise.reject(withStatus(error.response.data, 401));
          } else {
            let errorData = error?.response?.data;
            if (errorData) {
              if (errorData?.message?.length > 1) {
                // toast.error(errorData.message);
              } else {
                // toast.error(errorData.errorDetail);
              }
            }
            return Promise.reject(errorData);
          }
        } else if (error.request) {
          return Promise.reject(error.request);
        } else {
          return Promise.reject(error);
        }
      }
    );
    for (const method of ["get", "post", "put", "delete"]) {
      this[method] = this.http[method];
    }
  }
}